import React from 'react';
import { NavLink, Link } from 'react-router-dom';

const linkClass = ({ isActive }) =>
  `nav-link${isActive ? ' fw-bold' : ''}`;

const linkStyle = { color: '#ffffff' };

export default function Navbar() {
  return (
    <nav className="navbar navbar-expand-md navbar-dark bg-dark" style={{ paddingTop: '0.8rem', paddingBottom: '0.8rem' }}>
      <div className="container">
        <Link to="/" className="navbar-brand d-flex align-items-center">
          <img src='/img/logoHorizontalBranca1.png' alt="IAC Buritama" style={{ height: '38px', width: 'auto' }} />
        </Link>

        <button
          className="navbar-toggler border-0 shadow-none"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarContent"
          aria-controls="navbarContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarContent">
          <ul
            className="navbar-nav ms-auto mb-2 mb-md-0 align-items-md-center gap-md-4 mt-3 mt-md-0"
            style={{ fontSize: '0.9rem', fontWeight: 500, letterSpacing: '0.2px' }}
          >
            <li className="nav-item">
              <NavLink to="/" end className={linkClass} style={linkStyle}>
                Início
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/encerrados" className={linkClass} style={linkStyle}>
                Eventos Encerrados
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/minhas-inscricoes" className={linkClass} style={linkStyle}>
                Minhas Inscrições
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
